<template>
	<div id="plants">
		<b-row class="text-center">
			<b-col>
				<b-button @click="decreaseRows()" variant="outline-primary"><b-icon-arrow-left-short></b-icon-arrow-left-short></b-button>
				{{plants.filter(thisUser).length==0?0:numRows+1}} to {{(numRows+5)>plants.filter(thisUser).length? plants.filter(thisUser).length:numRows+5}} of {{plants.filter(thisUser).length}}
				<b-button @click="increaseRows()" variant="outline-primary"><b-icon-arrow-right-short></b-icon-arrow-right-short></b-button>
			</b-col>
		</b-row>
		<br>
		<b-row class="tableHeader text-center">
			<b-col cols="1">ID</b-col>
			<b-col cols="2">Scientific Name</b-col>
			<b-col cols="1">Common Name</b-col>
			<b-col cols="1">Family</b-col>
			<b-col cols="1">Origin</b-col>
			<b-col cols="4">Image(Click to enlarge)</b-col>
			<b-col cols="2"></b-col>
		</b-row>

		<ul>
			<li>
				<b-row class="text-left">
					<b-col cols="1"></b-col>
					<b-col cols="2"><b-form-input v-model="scientificName" type="text" placeholder="Scientific Name" onfocus="this.value=''"></b-form-input></b-col>
					<b-col cols="1"><b-form-input v-model="commonName" type="text" placeholder="Common Name" onfocus="this.value=''"></b-form-input></b-col>
					<b-col cols="1"><b-form-input v-model="family" type="text" placeholder="Family" onfocus="this.value=''"></b-form-input>
					</b-col><b-col cols="1">
						<b-form-input v-model="origin" type="text" placeholder=" Origin" onfocus="this.value=''"></b-form-input></b-col>
						<b-col cols="4"> <b-form-file 
							v-model="image"
							accept=".jpg, .png, .gif" 
							@change="onChange"
							placeholder="Choose a file or drop it here..."
							drop-placeholder="Drop file here..."
							></b-form-file></b-col>
							<b-col cols="2"> <b-button @click="submit()" style="width:100%"><b-icon-plus></b-icon-plus></b-button></b-col>
						</b-row>
					</li>
				</ul>

				<div class="tableBody text-center">
					<ul>
						<li v-for="plant of plants.filter(thisUser).slice().reverse().slice(numRows, numRows+5)" v-bind:key="plant['.key']" class="tableElement">
							<div v-if="!plant.edit">
								<b-row>
									<b-col cols="1">
										{{plant.id}}
									</b-col>
									<b-col cols="2">
										{{plant.scientificName}}
									</b-col>
									<b-col cols="1">{{plant.commonName}}</b-col>
									<b-col cols="1">{{plant.family}}</b-col>
									<b-col cols="1">{{plant.origin}}</b-col>
									<b-col cols="4"><b-img-lazy v-b-modal="plant['.key']"  :src="plant.url" fluid alt="No image" id="img" width="100px"></b-img-lazy>
										<b-modal v-bind:id="plant['.key']" size="lg" hide-footer hide-header>
											<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(plant['.key'])"><b-icon-x></b-icon-x></b-button>
											<b-img-lazy :src="plant.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
										</b-modal>
									</b-col>
									<b-col cols="2">
										<b-button-group>
											<b-button variant="outline-primary" @click="setEdit(plant['.key'])"><b-icon-pencil></b-icon-pencil></b-button>
											<b-button  variant="danger" @click="remove(plant['.key'], plant)"><b-icon-trash></b-icon-trash></b-button>
										</b-button-group>
									</b-col>
								</b-row>
							</div>
							<div v-else>
								<b-row>
									<b-col cols="1">{{plant.id}}</b-col>
									<b-col cols="2"><b-form-input type="text" v-model="plant.scientificName" placeholder="Scientific Name"></b-form-input></b-col>
									<b-col cols="1"><b-form-input type="text" v-model="plant.commonName" placeholder="Common Name"></b-form-input></b-col>
									<b-col cols="1"><b-form-input type="text" v-model="plant.family" placeholder="Common Name"></b-form-input></b-col>
									<b-col cols="1"><b-form-input type="text" v-model="plant.origin" placeholder="Common Name"></b-form-input></b-col>
									<b-col cols="4"><b-form-file
										@change="onChange"
										placeholder="Choose a file or drop it here..."
										drop-placeholder="Drop file here..."
										></b-form-file></b-col>
										<b-col cols="2">
											<b-button-group>
												<b-button @click="saveEdit(plant)"><b-icon-check></b-icon-check></b-button>
												<b-button variant="danger" @click="cancelEdit(plant['.key'])"><b-icon-x></b-icon-x></b-button>
											</b-button-group></b-col>
										</b-row>               
									</div>
								</li>
							</ul>
						</div>
						<div id="snackbar">{{toastMessage}}</div>
					</div>
				</template>

				<style>
				#plants {
					font-family: 'Avenir', Helvetica, Arial, sans-serif;
					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					color: #2c3e50;
					padding: 50px 50px 50px 50px;
				}

				.tableHeader{
					background-color: #343a40;
					color: white;
					margin-bottom: 10px;
					padding: 10px 10px 10px 10px;
				}

				.tableBody{
					display:block;

				}

				h1, h2 {
					font-weight: normal;
				}

				ul {
					list-style-type: none;
					padding: 0;
				}

				li {
					margin: 10px 10px;
				}

				a {
					color: #42b983;
				}

				#snackbar {
					visibility: hidden; /* Hidden by default. Visible on click */
					min-width: 250px; /* Set a default minimum width */
					margin-left: -125px; /* Divide value of min-width by 2 */
					background-color: #333; /* Black background color */
					color: #fff; /* White text color */
					text-align: center; /* Centered text */
					border-radius: 2px; /* Rounded borders */
					padding: 16px; /* Padding */
					position: fixed; /* Sit on top of the screen */
					z-index: 1; /* Add a z-index if needed */
					left: 45%; /* Center the snackbar */
					bottom: 30px; /* 30px from the bottom */
				}


				#snackbar.show {
					visibility: visible; 
					-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
					animation: fadein 0.5s, fadeout 0.5s 2.5s;
				}

				/* Animations to fade the snackbar in and out */
				@-webkit-keyframes fadein {
					from {bottom: 0; opacity: 0;}
					to {bottom: 30px; opacity: 1;}
				}

				@keyframes fadein {
					from {bottom: 0; opacity: 0;}
					to {bottom: 30px; opacity: 1;}
				}

				@-webkit-keyframes fadeout {
					from {bottom: 30px; opacity: 1;}
					to {bottom: 0; opacity: 0;}
				}

				@keyframes fadeout {
					from {bottom: 30px; opacity: 1;}
					to {bottom: 0; opacity: 0;}
				}
				</style>

				<script>
				import { plantRef } from '../firebase';
				import { firebaseStorage } from '../firebase';
				export default {
					name: 'plants',
					data () {
						return {
							plants: [],
							image: null,
							scientificName: '',
							commonName: '',
							family: '',
							origin: '',
							toastMessage: '',
							uploadTask: false,
							numRows: 0
						}
					},
					firebase: {
						plants: plantRef 
					},
					methods: {
						submit() {
							if(this.scientificName === '' || this.image == null || this.commonName === '' || this.family === '' || this.origin === ''){
								this.showSnackBar('Please fill out all the fields');
								return;
							}

							var date = new Date();
							var imageName = this.image.name+date;
							var task = firebaseStorage.child(imageName).put(this.image);   
							task.on('state_changed', function(snapshot){
								var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
								console.log('Upload is ' + progress + '% done');
							});

							task.on(
								'state_changed',
								null,
								null,
								() => {
									console.log('upload complete!');
									if(this.plants.length>0){
										firebaseStorage.child(imageName).getDownloadURL().then((url) => { 
											plantRef.push({scientificName: this.scientificName, url: url,fileName: imageName,edit:false,  commonName: this.commonName, family: this.family, origin: this.origin,
												id: parseInt(this.plants[this.plants.length-1].id)+1, user: this.getUser()});
										});

									}else {
										firebaseStorage.child(imageName).getDownloadURL().then((url) => { 
											plantRef.push({scientificName: this.scientificName, url: url,fileName: imageName,edit:false,  commonName: this.commonName, family: this.family, origin: this.origin,
												id: 1, user: this.getUser() });
										});
									}
								});

							this.showSnackBar('Plant Added');
							this.image = null;

						},
						remove(key, plant) {
							try{  
								plantRef.child(key).remove();
								firebaseStorage.child(plant.fileName).delete();
								this.showSnackBar('Plant Removed');
							}catch(e){
								console.log('There was no image in the deleted item');
							}
						},
						setEdit(key){
							plantRef.child(key).update({edit: true});
						},
						cancelEdit(key){
							plantRef.child(key).update({edit: false});
						},
						saveEdit(plant){
							if(plant.scientificName === '' || plant.commonName === '' || plant.family === '' || plant.origin === ''){
								this.showSnackBar('Please fill out all the fields');
								return;
							}
							const key = plant['.key'];
							if(this.image != null){
								var date = new Date();
								var imageName = this.image.name+date;
								var task = firebaseStorage.child(imageName).put(this.image);  
								task.on('state_changed', function(snapshot){
									var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
									console.log('Upload is ' + progress + '% done');
								});
								task.on(
									'state_changed',
									null,
									null,
									() => {
										console.log('upload complete!');
										firebaseStorage.child(imageName).getDownloadURL().then((url) => { 
											plantRef.child(key).update({scientificName: plant.scientificName, url: url,fileName: imageName,edit:false, commonName: plant.commonName, family: plant.family, origin: plant.origin});
											try{
												firebaseStorage.child(plant.fileName).delete();
											}catch(e){
												console.log('File was not deleted');
											}
										});
									});
							}else{
								plantRef.child(key).update({scientificName:plant.scientificName, edit: false, commonName: plant.commonName, family: plant.family, origin: plant.origin});
							}

							this.showSnackBar('Plant Updated');
						},
						onChange(event){
							this.image = event.target.files[0];
						},
						showSnackBar(message){
							this.toastMessage = message;
							var x = document.getElementById("snackbar");
							x.className = "show";
							setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
						},
						increaseRows(){
							if((this.plants.filter(this.thisUser).length-this.numRows-5)>0){
								this.numRows+=5
							}
						},
						decreaseRows(){
							if((this.numRows>=5)){
								this.numRows-=5
							}
						},
						getUser(){
							return this.$parent.activeUser?this.$parent.activeUser.name:'';
						},
						thisUser(plant){
							return (plant.user == this.getUser() || this.getUser() == 'Reiman Gardens')?plant:null
						}
					}
				}
				</script>

